import React from 'react';

export default function ToastMsg({ data }) {
  return (
    <div className="toast-container">
      <p className="toast-title">{data.title}</p>
      <p className="toast-description">{data.text}</p>
    </div>
  )
}
